import { render, staticRenderFns } from "./UpgradeMessageBox.vue?vue&type=template&id=255ce6c4&"
import script from "./UpgradeMessageBox.vue?vue&type=script&lang=js&"
export * from "./UpgradeMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports